import { render, staticRenderFns } from "./Radiator.vue?vue&type=template&id=33ddcee0&"
import script from "./Radiator.vue?vue&type=script&lang=js&"
export * from "./Radiator.vue?vue&type=script&lang=js&"
import style0 from "./Radiator.vue?vue&type=style&index=0&id=33ddcee0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports